import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { Language } from "./type";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: {
        translations: {
          safetyOrderRearGarage:
            "Sicherheit und Ordnung in der Wohnmobil-Heckgarage",
          cargoSecurityRearGarage:
            "Ladungssicherung in der Wohnmobil-Heckgarage",
          noProblemWithAllsafe: "Kein Problem mit allsafe!",
          customCargoSecuritySolutions:
            "Wir bieten individuelle Lösungen um die Ladung in der Heckgarage professionell zu sichern. Egal ob es sich um ein neues Fahrzeug handelt oder ob Sie die Heckgarage an einem bestehenden Fahrzeug nachrüsten wollen. Sprechen Sie uns an und gemeinsam finden wir eine passende Lösung für Ihren Anwendungsfall.",
          exploreMoreRear: "Werfen Sie einen Blick auf unseren",
          rearGarageFlyer: "Heckgaragen-Flyer.",
          ourProductRange: "Unser Sortiment",
          airlineRails: "Airline Schienen",
          airlineRailBaseInfiniteOptions:
            "Die Airline-Schiene ist die Basis für einen Baukasten mit fast unendlich vielen Möglichkeiten. Sie bietet eine hohe Belastbarkeit bei gleichzeitig geringem Gewicht, einfacher Reinigung und ergonomischer Gestaltung.",
          allsafeExteriorRailEce324:
            "Die allsafe Exterior-Schiene erfüllt derzeit als einzige Airline-Schiene im Markt die Anforderungen nach ECE 324 R26 und ist dank Eloxal-Oberfläche für die Montage außen am Fahrzeug geeignet.",
          fittings: "Fittinge",
          airlineRailLightSemicylindrical:
            "(1) Airline-Schiene light, halbrund",
          airlineRailSpecialExterior:
            "(2) Airline-Schiene Spezial, Exterior-Schiene",
          miniAirlineRail: "(3) Mini Airline-Schiene",
          kerlButlerPerformsAsExpected:
            "KERL Butler macht seinem Namen alle Ehre: Er dient Ihnen bei fast jeder Transportaufgabe und sorgt stets für Ordnung. Er verbiegt und verdreht sich, genau so, wie Sie es wünschen. Und wenn Sie ihn einmal nicht benötigen, ist er mit einem Handgriff aus der Airline-Schiene entnommen.",
          kerlCaravanToolFreeInstallation:
            "Der KERL Caravan wird ohne Werkzeug in die Airline-Schiene eingesetzt und verklemmt. Kunststoffboxen, Fahrradträger und verschiedene Behälter können mit einem Handgriff in der Airline-Schiene fixiert werden. Ideal für alles, was schnell ein- und wieder ausgebaut wird.",
          kerlJimM8: "KERL JIM M8",
          kerlJimM8InternalThread:
            "Ein Innengewinde überall dort, wo Sie es brauchen. Und wenn Sie es morgen an einer anderen Stelle brauchen? Dann schieben Sie den KERL JIM M8 einfach dort hin. Oder Sie nehmen ihn mit einem Handgriff aus der Airline-Schiene heraus. KERL JIM M8 klappert nicht, fällt nicht un-beabsichtigt aus der Airline-Schiene heraus und steht nicht hervor. Ein kleines Befestigungs-Genie!",
          gurte: "Gurte",
          kerl500ClampLockStrap: "KERL 500 und Klemmschlossgurt",
          clampLockStrapsWithKerl500:
            "Klemmschlossgurte mit KERL-500-Beschlag sind die Universalgenies der Ladungssicherung. Mit ihnen können Sie fast alles schnell und einfach sichern: Egal ob Skiausrüstung, Campingmöbel oder Transportboxen – selbst Grills finden mit ihnen sicheren Halt während der Fahrt.",
          kerl500AvailableIndividually:
            "Den KERL 500 gibt es natürlich auch lose. Warum wir den KERL 500 genannt haben? Vielleicht auch, weil er Sie bei bestimmt 500 verschiedenen Ladungssicherungs-Aufgaben unterstützt.",
          kerl500V2aRustResistant:
            "Für die Exterior-Schiene und bei allen Einsätzen außen am Fahrzeug empfehlen wir den rostfreien KERL 500 V2A. Selbstverständlich passen KERL 500 und KERL 500 V2A in alle allsafe Airline-Schienen.",
          lockingRods: "Sperrstangen",
          kim4x4Airline: "KIM 4x4 Airline",
          kim4x4DualPurposeLockingRod:
            "KIM 4x4 ist doppelt praktisch: Diese Sperrstange sichert zum einen Ihre wertvolle Ladung, zum anderen erweitern die serienmäßigen Airline-Schienen die Stau- und Befestigungsmöglichkeiten in Ihrer Heckgarage.",
          cleverDetailsTwistLockOperatingStrap:
            "Pfiffige Details wie die Verdrehsicherung und der Bediengurt erleichtern das Handling – und wenn KIM 4x4 einmal nicht benötigt wird, kann sie ganz einfach entnommen und an anderer Stelle eingesetzt werden.",
          contactNow: "Jetzt kontaktieren.",
          togetherWeFindSolution:
            "Gemeinsam finden wir eine Lösung zur Sicherung Ihrer Ladung.",
          privacyStatement: "Datenschutzerklärung",
          cookieSettings: "Cookie-Einstellungen",
          imprint: "Impressum",
          termsAndConditions: "AVB",
        },
      },
      en: {
        translations: {
          safetyOrderRearGarage:
            "Safety and order for your motorhome rear garage",
          cargoSecurityRearGarage:
            "Load securing for rear motorhome garages",
          noProblemWithAllsafe: "No problem with the allsafe system!",
          customCargoSecuritySolutions:
            "We supply individual solutions to secure load in rear garages. These professional components fit to factory new vehicles as well as to used vehicles. Please do not hesitate to ask us for supporting you in finding the perfect solution for your vehicle!",
          exploreMoreRear: "Find more in our rear",
          rearGarageFlyer: "garage catalogue",
          ourProductRange: "Product range",
          airlineRails: "Airline tracks",
          airlineRailBaseInfiniteOptions:
            "The airline track is the base for a huge load securing kit with almost infinity possibilities: high strength, a low mass, easy to clean and ergonomic design make the airline track uniqe.",
          allsafeExteriorRailEce324:
            "The allsafe exterieur airline track is untill now the only airline track available that complies with ECE 324 R26. Its black anodized surface makes it suitable for exterieur applications.",
          airlineRailLightSemicylindrical: "(1) Airline track semi circular",
          airlineRailSpecialExterior: "(2) Exterieur airline track ",
          miniAirlineRail: "(3) Mini Airline-Tracks",
          kerlCaravanToolFreeInstallation:
            "KERL Caravan easy to fit without any tools. It just clamps into the airline track to assemble almost anything into your airline track, e.g. various boxes or bicycle racks. Easily assemble and disassemble your devices with one hand!",
          kerlButlerPerformsAsExpected:
            "KERL Butler is a must-have in every camping caravan: It helps you to keep almost everything in place. It turns and twists as you like - as flexible as your requirements! And if you don't need your Butler at the moment: just remove it from your airline track within a second.",
          fittings: "Fittings",
          kerlJimM8: "KERL JIM M8",
          kerlJimM8InternalThread:
            "KERL JIM M8 supplies a female thread everywhere you require one. But what if you need it somewhere else? Just slide KERL JIM M8 there. Or remove it from your airline track with one hand. KERL JIM M8 offers a non-rattle-design and a smart clamping system to not fall of the airline track during assembly process.",
          gurte: "Belts",
          kerl500ClampLockStrap: "KERL 500 and cam buckle strap",
          clampLockStrapsWithKerl500:
            "Cam buckle straps with KERL 500 are little geniusses for load securing. They support various load securing jobs: Ski equipment, outdoor furniture, universal boxes - even barbecue grills can be easily and safely secured.",
          kerl500AvailableIndividually:
            "KERL 500 is also available seperately. To support at least 500 different load securing tasks - maybe this is one reason why we call it KERL 500.",
          kerl500V2aRustResistant:
            "For all exterieur applications we recommend the inox-Version of KERL 500. We guarantee a 100 % perfect fit with all original allsafe airline tracks for all KERL 500.",
          lockingRods: "Shoring bars",
          kim4x4Airline: "KIM 4x4 Airline",
          kim4x4DualPurposeLockingRod:
            "Make it double with KIM 4x4: This shoring bar is not only a shoring bar but also an airline track! This gives you additional load securing options in your rear garage.",
          cleverDetailsTwistLockOperatingStrap:
            "Smart details support the easy handling. And just in case you sometimes don't need your KIM 4x4: Just remove it from the airline track and store it somewhere else.",
          contactNow: "Contact us.",
          togetherWeFindSolution:
            "Together we will find a solution for your load securing project.",
          privacyStatement: "Privacy disclaimer",
          cookieSettings: "Cookie settings",
          imprint: "Imprint",
          termsAndConditions: "GCS",
        },
      },
      fr: {
        translations: {
          safetyOrderRearGarage:
            "Ordre et sécurité dans la soute du camping-car",
          cargoSecurityRearGarage:
            "Sécurisation du chargement dans la soute du camping-car",
          noProblemWithAllsafe: "Pas de problème avec allsafe!",
          customCargoSecuritySolutions:
            "Nous proposons des solutions individuelles pour sécuriser et organiser de manière professionnelle le chargement dans la soute du camping-car. Qu'il s'agisse d'un nouveau véhicule ou que vous souhaitiez équiper la soute d'un véhicule existant. Contactez-nous et nous trouverons ensemble une solution adaptée à votre cas d'application.",
          exploreMoreRear:
            "Jetez un coup d'œil à notre dépliant sur la soute du camping-car.",
          rearGarageFlyer: "Voir le dépliant.",
          ourProductRange: "Notre assortiment",
          airlineRails: "Rails aéro",
          airlineRailBaseInfiniteOptions:
            "Le rail aéro est la base d‘un système modulaire offrant un nombre presque infini de possibilités. Il offre une grande capacité de charge tout en étant légère, facile à nettoyer et ergonomique.",
          allsafeExteriorRailEce324:
            "Le rail Exterior d‘allsafe est actuellement le seul rail du marché à répondre aux exigences de la norme ECE 324 R26 et, grâce à sa surface anodisé, adapté au montage à l‘extérieur du véhicule.",
          airlineRailLightSemicylindrical:
            "(1) Rail aéro léger, semi-circulaire",
          airlineRailSpecialExterior: "(2) Rail aéro spécial, Rail-Exterior",
          miniAirlineRail: "(3) Rail aéro mini",
          kerlCaravanToolFreeInstallation:
            "Le KERL Caravan s‘insère et se bloque sans outil dans le rail aéro. Les boîtes en plastique, les porte-vélos et les différents conteneurs peuvent être fixés en un tour de main dans le rail aéro. Idéal pour tout ce qui doit être monté et démonté rapidement.",
          kerlButlerPerformsAsExpected:
            "KERL Butler fait honneur à son nom : il est à votre service pour presque toutes les tâches de transport et il veille toujours à l‘ordre. Il se plie et se tord, exactement comme vous le souhaitez. Et si vous n‘en avez pas besoin, il peut être retiré du rail aéro en un tour de main.",
          fittings: "Fittings",
          kerlJimM8: "KERL JIM M8",
          kerlJimM8InternalThread:
            "Un filetage intérieur partout où vous en avez besoin. Et si demain vous en avez besoin ailleurs ? Alors il vous suffit de glisser le KERL JIM M8 à cet endroit. Ou vous le retirez du rail aéro en un tour de main. Le KERL JIM M8 ne fait pas de bruit, ne tombe pas accidentellement hors du rail aéro et ne dépasse pas. Un petit génie de la fixation !",
          gurte: "Sangles",
          kerl500ClampLockStrap: "Sangle de serrage",
          clampLockStrapsWithKerl500:
            "Les sangles de serrage avec embout KERL 500 sont les génies universels de l‘arrimage des charges.",
          kerl500AvailableIndividually:
            "Elles permettent de sécuriser presque tout rapidement et facilement : qu‘il s‘agisse d‘équipement de ski, de meubles de camping ou de caisses de transport, même les barbecues sont bien maintenus pendant le trajet.",
          kerl500V2aRustResistant:
            "Pour le rail Exterior et pour toutes les utilisations à l‘extérieur du véhicule, nous recommandons le KERL 500 en acier inoxydable. Bien entendu, le KERL 500 et KERL 500 inoxydable s‘adaptent à tous les rails airline d‘allsafe.",
          lockingRods: "Barres d’arrimage",
          kim4x4Airline: "KIM 4x4 Airline",
          kim4x4DualPurposeLockingRod:
            "KIM 4x4 Airline est doublement pratique : d‘une part, cette barre de blocage sécurise votre précieux chargement et, d‘autre part, les rails aéro de série élargissent les possibilités de rangement et de fixation dans votre soute.",
          cleverDetailsTwistLockOperatingStrap:
            "Des détails astucieux comme le dispositif anti-torsion et la sangle facilitent la manipulation. Et si la KIM 4x4 n‘est pas utilisée, elle peut être retirée très facilement et utilisée ailleurs.",
          contactNow: "Contactez-nous maintenant !",
          togetherWeFindSolution:
            "Ensemble, nous trouverons une solution pour sécuriser votre chargement. ",
          privacyStatement: "Déclaration de confidentialité",
          cookieSettings: "Paramètres des cookies",
          imprint: "Imprimer",
          termsAndConditions: "CGV",
        },
      },
      nl: {
        translations: {
          safetyOrderRearGarage:
            "Orde en veiligheid in de garage",
          cargoSecurityRearGarage:
            "Ladingzekering in de camper-garage",
          noProblemWithAllsafe: "Geen probleem met allsafe!",
          customCargoSecuritySolutions: "Wij bieden individuele oplossingen om de lading in de garage professioneel vast te zetten. Of het nu gaat om een nieuw voertuig of dat u achteraf de garage van een bestaand voertuig hiervan wilt voorzien. Neem contact met ons op en samen vinden we een passende oplossing voor uw toepassingswens.",
          exploreMoreRear: "Bekijk onze camper-garage flyer.",
          rearGarageFlyer: "Camper-garage flyer.",
          ourProductRange: "Ons assortiment",
          airlineRails: "Vliegtuigrail",
          airlineRailBaseInfiniteOptions:
            "De vliegtuigrail is de basis voor ontelbare mogelijkheden om uw lading vast te zetten. En dat allemaal met een hoge belastbaarheid, laag eigen gewicht, eenvoudig schoon te maken en een ergonomisch ontwerp.",
          allsafeExteriorRailEce324: "De allsafe Exterior-vliegtuigrail is momenteel de enige rail die voldoet aan ECE 324 R26 en is dankzij de geanodiseerde oppervlakte behandeling geschikt voor montage aan de buitenzijde van uw voertuig.",
          fittings: "Fittingen",
          airlineRailLightSemicylindrical:
            "(1) Vliegtuigrail light, halfrond",
          airlineRailSpecialExterior:
            "(2) Vliegtuigrail speciaal, Exterior vliegtuigrail",
          miniAirlineRail: "(3) Mini Airline rail",
          kerlButlerPerformsAsExpected:
            "KERL Butler doet zijn naam eer aan. Hij helpt u bij ieder transport en zorgt altijd voor orde in uw garage. Hij beweegt en draait, precies naar uw wens. En als u de KERL Butler even niet nodig heeft, dan kunt u deze met 1 simpele handeling uit de rail nemen.",
          kerlCaravanToolFreeInstallation:
            "De KERL Caravan kunt u zonder gereedschap in de vliegtuigrail vastzetten. Kunststof kisten, fietssteunen of andere type houders kunnen met een simpele handeling in de vliegtuigrail vastgezet worden. Ideaal voor alles wat snel in- en uitgebouwd moet worden.",
          kerlJimM8: "KERL JIM M8",
          kerlJimM8InternalThread:
            "Een schroefpunt daar waar u het nodig heeft. En als u het morgen ergens anders nodig heeft? Dan schuift u de KERL JIM M8 gewoon naar de nieuwe gewenste plek. Of u neemt hem eenvoudig uit de rail. De KERL JIM M8 rammelt niet en valt nooit onbedoeld uit de rail. Een geniale oplossing!",
          gurte: "Spanbanden",
          kerl500ClampLockStrap: "KERL 500 en spanbanden met klemgesp",
          clampLockStrapsWithKerl500: "De spanband met klemgesp voorzien van KERL 500 fittingen zijn de universele genieën van de ladingzekering. Hiermee kunt u bijna alles snel en eenvoudig vastzetten. Of het nu uw skiuitrusting, campingmeubels of transportkisten zijn. Zelfs uw barbecue neemt u veilig mee op reis.",
          kerl500AvailableIndividually:
            "De KERL 500 kunt u ook los gebruiken in de vliegtuigrail. Waarom heet hij eigenlijk KERL 500? Misschien ook wel omdat u er zeker 500 verschillende toepassingen voor kunt verzinnen.",
          kerl500V2aRustResistant:
            "Voor de Exterior-vliegtuigrail en bij alle andere toepassingen buiten het voertuig, bevelen wij u de roestvaststalen KERL 500 V2A aan. Uiteraard passen de KERL 500 en de KERL 500 V2A (RVS) in alle allsafe vliegtuigrail.",
          lockingRods: "Sperstangen",
          kim4x4Airline: "KIM 4x4 Airline",
          kim4x4DualPurposeLockingRod: "De KIM 4x4 is dubbel praktisch: in eerste instantie blokkeert hij uw waardevolle lading, daarnaast vergroten de standaard Airline-rails op de sperstang, de opberg- en bevestigingsmogelijkheden in uw garage.",
          cleverDetailsTwistLockOperatingStrap:
            "Slimme details zoals de anti-draaifitting en het bedienkoord maken het gebruik erg makkelijk. – en als de KIM 4x4 even niet gebruikt hoeft te worden zet u deze eenvoudig op een andere plaats waar hij niet in de weg staat.",
          contactNow: "Neem nu contact op.",
          togetherWeFindSolution:
            "Samen vinden we een oplossing voor het vastzetten van uw lading.",
          privacyStatement: "Privacyverklaring",
          cookieSettings: "Cookie-instellingen",
          imprint: "Colofon",
          termsAndConditions: "AVB",
        },
      },
    },
    fallbackLng: "de",
    supportedLngs: Object.values(Language),
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
